/* Ondellia · ficha del polvo: galería, packs de respaldo y "ver más reseñas".
   Sin librerías. Se carga con defer. */
(function () {
  // Galería: flechas, deslizar, puntos, contador, teclado y miniatura centrada
  document.querySelectorAll('[data-pv-gallery]').forEach(function (root) {
    var slides = root.querySelectorAll('[data-pv-slide]');
    var thumbs = root.querySelectorAll('.pv-gallery__thumb');
    var dots = root.querySelectorAll('.pv-gallery__dot');
    var strip = root.querySelector('.pv-gallery__thumbs');
    var count = root.querySelector('.pv-gallery__count');
    var total = slides.length;
    if (total < 2) return;
    var current = 0;
    var last = -1;

    function show(i) {
      current = (i + total) % total;
      slides.forEach(function (s, n) {
        s.hidden = n !== current;
        if (n === current && s.loading === 'lazy') s.loading = 'eager';
      });
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === current);
        t.setAttribute('aria-current', n === current ? 'true' : 'false');
      });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === current); });
      if (count) count.textContent = (current + 1) + ' / ' + total;
      // El último índice se guarda en la instancia, no se deduce del DOM
      if (last !== current && strip && thumbs[current]) {
        var t = thumbs[current];
        strip.scrollTo({ left: t.offsetLeft - strip.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
      }
      last = current;
    }

    root.querySelectorAll('[data-pv-step]').forEach(function (b) {
      b.addEventListener('click', function () { show(current + Number(b.getAttribute('data-pv-step'))); });
    });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });

    var main = root.querySelector('.pv-gallery__main');
    var startX = null;
    main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(dx) < 40) return;
      show(dx < 0 ? current + 1 : current - 1);
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') show(current - 1);
      if (e.key === 'ArrowRight') show(current + 1);
    });

    show(0);
  });

  // Packs de respaldo (se ocultan por CSS cuando Kaching pinta los suyos)
  document.querySelectorAll('[data-pv-packs]').forEach(function (group) {
    var buy = group.closest('.pv-buy');
    var qty = buy && buy.querySelector('input[name="quantity"]');
    group.querySelectorAll('[data-pv-pack]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        group.querySelectorAll('[data-pv-pack]').forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        if (qty) qty.value = btn.getAttribute('data-qty') || '1';
      });
    });
  });

  // Ver más / ver menos reseñas
  document.querySelectorAll('[data-pv-rev-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var grid = btn.closest('.pv-rev').querySelector('[data-pv-reviews]');
      var open = btn.getAttribute('aria-expanded') === 'true';
      grid.querySelectorAll('[data-extra]').forEach(function (el) { el.hidden = open; });
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      btn.textContent = open ? btn.dataset.more : btn.dataset.less;
    });
  });
})();
